

class ReplaceSVG {
  constructor(callback, selector) {
    this.selector = '.js-replace-svg'
    this.callback = callback
  }
  replace() {

    const placeholder = document.querySelectorAll('.js-replace-svg:not(.--replaced)')
    if(!placeholder.length) return
    let loaded = 0

    placeholder.forEach(el => {
      const xhr = new XMLHttpRequest()
      xhr.onload = (e) => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            loaded += 1
            el.innerHTML = xhr.responseText
            el.classList.add('--replaced')
          } else {
            loaded += 1
          }
          if(loaded === placeholder.length) {
            this.callback(this)
          }
        }
      };
      xhr.open('GET', el.dataset.svg)
      xhr.send()
  
    })
  }
  callback() {
    // do something
  }
}

export default ReplaceSVG